import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "repositorySdgs",
  initialState: {
    list: [],
    count: 0,
  },
  reducers: {
    setSDG: (state, { payload: list }) => {
      return {
        ...state,
        list,
      };
    },

    countSDG: (state, { payload: count }) => {
      return {
        ...state,
        count,
      };
    },
  },
});

export const { setSDG, countSDG } = slice.actions;

export default slice.reducer;

export const getSDGSelector = (store) => store.repositorySdgs.list;
export const getSDGCountSelector = (store) => store.repositorySdgs.count;
